import React from 'react';

export default function warning() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" fill="none">
      <path
        d="M9.5752 16.1758C13.3031 16.1758 16.3252 13.1537 16.3252 9.42578C16.3252 5.69786 13.3031 2.67578 9.5752 2.67578C5.84727 2.67578 2.8252 5.69786 2.8252 9.42578C2.8252 13.1537 5.84727 16.1758 9.5752 16.1758Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.5752 6.05078V9.98828"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5752 13.3633C10.0412 13.3633 10.4189 12.9855 10.4189 12.5195C10.4189 12.0535 10.0412 11.6758 9.5752 11.6758C9.10921 11.6758 8.73145 12.0535 8.73145 12.5195C8.73145 12.9855 9.10921 13.3633 9.5752 13.3633Z"
        fill="currentColor"
      />
    </svg>
  );
}
